import axiosClient from './axiosClient';

const rideBookingApi = {
  getBookings: (params) => axiosClient.get('/rides/bookings', { params }),
  getBooking: (bookingId) => axiosClient.get(`/rides/bookings/${bookingId}`),
};

export default rideBookingApi;
